module.exports = __webpack_public_path__ + "static/colorRelianceNo-053089300367c6c2688e25f36f0c8d35.png";